import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/hotels';

class hotelService {
    createHotel(Hotel) {
        return axios.post(API_URL, Hotel);
    }

    getAllHotels() {
        return axios.get(API_URL);
    }

    getHotelById(id) {
        return axios.get(`${API_URL}/${id}`);
    }

    updateHotel(id, updatedHotel) {
        return axios.put(`${API_URL}/${id}`, updatedHotel);
    }

    deleteHotel(id) {
        return axios.delete(`${API_URL}/${id}`);
    }
}

export default new hotelService();
